
import Vue from "vue";
import { configStore, uiStore } from "@/store/store";
import { Component, Prop } from "vue-property-decorator";

import {
  BrowseModeSupportedUIPanels,
  toggleBrowseMode
} from "@/lib/browse-mode";
import PanelHeaderButton from "@/components/Reusable/Util/PanelHeaderButton.vue";

@Component({
  components: {
    PanelHeaderButton
  }
})
export default class BrowseModeToggle extends Vue {
  @Prop({ default: "globalSettings" })
  panelToOpen!: BrowseModeSupportedUIPanels;

  get isBrowseModeEnabled() {
    return uiStore.mode === "browse";
  }

  get isBrowseModeAvailable() {
    return configStore.builderMode === "breakdance";
  }

  toggleBrowseMode() {
    toggleBrowseMode(this.panelToOpen);
  }
}
